// Verificação prévia de disponibilidade de vídeo via YouTube Data API v3

export async function checkYoutubeVideoAvailability(videoId, apiKey) {
  if (!videoId || !apiKey) {
    return { available: null, reason: 'missing_params' };
  }

  try {
    const url = `https://www.googleapis.com/youtube/v3/videos?id=${encodeURIComponent(
      videoId
    )}&key=${encodeURIComponent(
      apiKey
    )}&part=status,contentDetails,snippet&hl=pt-BR`;
    const response = await fetch(url);

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.error && errorData.error.code === 400) {
        console.warn(
          'YouTube API: Invalid API key or request format',
          errorData.error
        );
        return {
          available: null,
          reason: 'api_key_invalid',
          error: errorData.error.message,
        };
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();

    if (data.error) {
      console.warn('YouTube API error:', data.error);
      return {
        available: null,
        reason: 'api_error',
        error: data.error.message || 'Unknown error',
      };
    }

    if (!data.items || data.items.length === 0) {
      return { available: false, reason: 'video_not_found' };
    }

    const video = data.items[0];
    const status = video.status;
    const contentDetails = video.contentDetails;

    // Verificar se vídeo está embedável
    if (status.embeddable === false) {
      return { available: false, reason: 'not_embeddable' };
    }

    // Verificar privacidade
    if (status.privacyStatus !== 'public') {
      return { available: false, reason: `privacy_${status.privacyStatus}` };
    }

    // Verificar upload status
    if (status.uploadStatus !== 'processed') {
      return { available: false, reason: `upload_${status.uploadStatus}` };
    }

    // Verificar restrição regional
    if (contentDetails && contentDetails.regionRestriction) {
      const restriction = contentDetails.regionRestriction;
      if (restriction.blocked && restriction.blocked.length > 0) {
        const userRegion = getUserRegion();
        if (restriction.blocked.includes(userRegion)) {
          return {
            available: false,
            reason: 'region_blocked',
            blockedIn: userRegion,
          };
        }
      }
    }

    return { available: true, video: video };
  } catch (error) {
    console.warn('YouTube API check failed:', error);
    return { available: null, reason: 'api_error', error: error.message };
  }
}

function getUserRegion() {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (
      timezone.includes('America/Sao_Paulo') ||
      timezone.includes('America/Fortaleza')
    ) {
      return 'BR';
    }
    return 'BR';
  } catch (e) {
    return 'BR';
  }
}

export function getYoutubeApiKey() {
  if (typeof window !== 'undefined' && window.youtubeApiKey) {
    const key = window.youtubeApiKey.trim();
    if (key !== '') {
      return key;
    }
  }
  return null;
}
